"use client"
import React from 'react';
import { motion } from 'framer-motion';
import { Project } from '@/data/projects';
import { fadeInUp, buttonHover } from '../animations';

interface ProjectHeaderProps {
  project: Project;
}

export const ProjectHeader: React.FC<ProjectHeaderProps> = ({ project }) => {
  return (
    <motion.div
      {...fadeInUp}
      className="mb-8 mt-24"
    >
    

      <h1 className="text-4xl font-bold mb-4">{project.title}</h1>
      <div className="flex items-center gap-4 text-gray-300 mb-6">
        <span>{project.role}</span>
        {project.company && (
          <>
            <span>•</span>
            <span>{project.company}</span>
          </>
        )}
        <span>•</span>
        <span>{project.period}</span>
      </div>
      <div className="flex flex-wrap gap-2 mb-6">
        {project.technologies.map((tech) => (
          <motion.span
            key={tech}
            className="px-3 py-1 bg-white/10 rounded-full text-sm"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          >
            {tech}
          </motion.span>
        ))}
      </div>
      <p className="text-lg text-gray-300 mb-6">{project.longDescription}</p>
      <div className="flex gap-4">
        {project.githubLink && (
          <motion.a
            href={project.githubLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors"
            {...buttonHover}
          >
            View on GitHub
          </motion.a>
        )}
        {project.liveLink && (
          <motion.a
            href={project.liveLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 bg-pink-500 hover:bg-pink-600 rounded-lg transition-colors"
            {...buttonHover}
          >
            Live Demo
          </motion.a>
        )}
      </div>
    </motion.div>
  );
}; 